module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_yasuura-0362923a8e68e9d51b0c187b599e4141.jpg";